import Constants from 'Constants'
import Data from 'Class/Data'

export default (option) => Data.list(Constants.module.CONFIGURATION, Constants.donnee.option).indexOf(option) !== -1